<template lang="pug">
  .tabs-select
    select-input(
      v-if="tabs.length > 1"
      :options="options"
      v-model="selected"
      disable-default
    )
    .tabs__content
      slot
</template>

<script>
  import SelectInput from 'scripts/components/forms/SelectInput.vue'
  export default {
    name: 'TabsSelect',
    data() {
      return {
        tabs: [],
        selected: '',
      };
    },
    components: {
      SelectInput,
    },
    computed: {
      options() {
        return this.tabs.map(tab => {
          return {
            label: tab.heading,
            value: tab.heading
          }
        });
      }
    },
    methods: {
      addTab(newTab) {
        this.tabs.push(newTab);
      },
      removeTab(tabToRemove) {
        const index = this.tabs.findIndex((tab) => tab.heading === tabToRemove.heading);
        this.tabs.splice(index, 1);
      },
      activate(heading) {
        this.tabs.forEach((tab) => {
          tab.$set(tab, 'active', Boolean(heading === tab.heading));
        });
      },
    },
    watch: {
      selected() {
        this.activate(this.selected);
      }
    }
  };
</script>

<style scoped lang="scss">
  .input--select {
    max-width: 440px;
    margin: 0 auto 20px;
  }

  .vs__selected {
    color: var(--color-navy-500);
  }

  .tabs {
    padding-bottom: 50px;
  }

  .tabs__nav {
    margin-bottom: $content-gutter;
  }

  .tabs__nav-button {
    cursor: pointer;
    background-color: transparent;
    position: relative;
    margin: 5px 20px 5px 0px;
    line-height: 1.5;
    padding: 0;
    border: 0;
    transition: 0.3s ease all;

    &:hover {}

    &:focus {
      outline: none;
    }

    &.active {}
  }
</style>
